const permissions = {
    search_placeholder: 'جستجو بر اساس API یا نام مجوز',
    search_placeholder_without_api: 'جستجو بر اساس نام مجوز',
    name_column: 'مجوز',
    description_column: 'توضیحات',
    api_column: 'API',
    placeholder_title: 'مجوز',
    placeholder_description: 'مجوز به معنای اجازه دسترسی به یک منبع (ما آن را منبع API می‌نامیم) است.',
    edit: 'ویرایش مجوز',
    delete: 'حذف مجوز',
    remove: 'حذف مجوز',
    edit_title: 'ویرایش مجوز API',
};
export default Object.freeze(permissions);
